import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const IndieDefinition = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.2 }}
      className="max-w-2xl mx-auto mb-24 text-center"
    >
      <div className="inline-block bg-gray-800/50 backdrop-blur rounded-2xl px-6 py-4 border border-gray-700">
       
        <div className="flex items-center justify-center gap-3 mb-2">
          <span className="text-gray-400 text-sm font-mono">trend·ing</span>
          <span className="text-gray-500 text-xl" style={{ letterSpacing: '2px' }}>/ˈtrendiNG/</span>
        </div>
        <span className="text-gray-400 text-xs uppercase tracking-wide">adjective</span>
          <p className="mt-1  mb-2">
            (of chess platforms, people, and products) gaining attention and momentum
            in the chess world; discoverable, connected, and community-driven.
          </p>
       
          <div className="text-white text-sm font-medium mt-4 " style={{ color: 'gold' }}>
          © 2025 TrendingChess.com
        </div>
      </div>
    </motion.div>
  );
};

export default IndieDefinition;